import React, { Component } from 'react'
import Headers from '../Layouts/Headers'
import TriageSidebar from '../Layouts/TriageSidebar'
import axios from 'axios'
import $ from 'jquery'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';

export class TriageDashboard extends Component {

	constructor(props) {
		super(props);
		const url = ''

		this.state = {

			module: '',
			profession: '',
			name: '',
			nationality: '',

		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(event) {
		this.setState({ [event.target.name]: event.target.value });

	}

	handleSubmit = event => {
		event.preventDefault()
		var moduleSelected = this.state['module']
		console.log(module)
		const headers = {
			'Content-Type': 'application/json',
			'token': localStorage.getItem('accessToken'),
			'visitid': localStorage.getItem('currentVisitId')
		}

		axios.post(this.api_url+"billing/status/" + moduleSelected + "/open", this.state, { headers: headers })
			.then(res => {
				//   const verified = res.data;
				console.log(res.data);
				if (res.data['status']) {
					$('.sendModuleSuccess').show()
					setTimeout(function (props) {
						$('.modal').hide()

					}, 3000);
				}
			})
			.catch(error => {
				console.log(error)
			})
		axios.post(this.api_url+"billing/status/triage/closed", this.state, { headers: headers })
			.then(res => {
				//   const verified = res.data;
				console.log(res.data);
				if (res.data['status']) {
					// alert('closed_successfully')
					$('.sendModuleSuccess').show()
					setTimeout(function (props) {
						$('.modal').hide()
					}, 3000);
				}
			})
			.catch(error => {
				console.log(error)
			})

	}





	componentDidMount() {



		console.log(localStorage.getItem('currentVisitId'))
		console.log(localStorage.getItem('currentVisitName'))
		console.log(localStorage.getItem('currentVisitNationality'))
		console.log(localStorage.getItem('currentVisitProfession'))
		//     const article = { title: 'React POST Request Example' };   
		// axios.post('https://reqres.in/api/articles', article)
		// .then(response => this.setState({ articleId: response.data.id }));

		$('.sendToModule').on('click', function () {
			$('.module_list').show();
		})
	}


	render() {

		const font16 = { fontSize: '16px' };
		const fontFamilyNunito = { fontFamily: 'Nunito, sans-serif' }
		const floatRight = { float: 'right' }
		const floatLeft = { float: 'left' }
		const displayHidden = { display: 'none' }
		let forgotPasswordUrl = '/forgot/password';
		const { module } = this.state;
		

		const {
			profession,
			name,
			nationality,
		} = this.state
		return (
			<div>
				<Headers />
				<section className="more-top-padding service-area" id="services">
					<div className="container">
						<div className="row">
							{/* <div className="card" style="width: 18rem;"> */}
							{/* <ul className="list-group list-group-flush">
    <li className="list-group-item">Cras justo odio</li>
    <li className="list-group-item">Dapibus ac facilisis in</li>
    <li className="list-group-item">Vestibulum at eros</li>
  </ul> */}
							{/* </div> */}
						</div><br /><br />

						<div className="row wow center bounceInUp" data-wow-duration="1.2s" data-wow-delay="1.2s">
							<div className="col-md-6 col-lg-4  col-sm-6 mb-4 center col-xs-12">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-pills"></i>
									</div>
									<h3><a href="/triage/antenatal/history"> Antenatal History </a> </h3>
									<p>
									</p>
								</div> */}

								<a className="navbar-brand" href="/triage/antenatal/history">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Antenatal History
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-ambulance"></i>
									</div>
									<h3><a href="/diagnosis/study">Diagnosis and Plan</a></h3>
									<p>
										Efficiency, speed and professionalism <br />is key with <br />our ambulance service
									</p>
								</div> */}
								<a className="navbar-brand" href="/triage/ob/sound">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Obstetrics UltraSound
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>

							</div>
							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-ambulance"></i>
									</div>
									<h3><a href="/diagnosis/study">Diagnosis and Plan</a></h3>
									<p>
										Efficiency, speed and professionalism <br />is key with <br />our ambulance service
									</p>
								</div>  */}
								<a className="navbar-brand" href="/previous/pregancy">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Previous Pregancy
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>

							</div>
							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-ambulance"></i>
									</div>
									<h3><a href="/diagnosis/study">Diagnosis Study</a></h3>
									<p>
										Efficiency, speed and professionalism <br />is key with <br />our ambulance service
									</p>
								</div>  */}
								<a className="navbar-brand" href="/history/taking">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Short History Taking
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>

							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-user-md"></i>
									</div>
									<h3><a href="/general/observations">General Observations</a></h3>
									<p>
										We have been recognized for our exceptional service and care by both international and local awarding bodies
									</p>
								</div> */}
								<a className="navbar-brand" href="/general/observations">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													General Observations
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>

							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-tint"></i>
									</div>
									<h3><a href="/menstrual/history">Menstrual History</a></h3>
									<p>
										Our team caters for your diagnosis <br />and treatment wih effectiveness<br />
										and outmost care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/menstrual/history">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Menstrual History
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>


							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-flask"></i>
									</div>
									<h3><a href="/physical/examination">Physical Examination</a></h3>
									<p>
										Pathology Laboratory performs tests on a Routine Basis and STAT according to the needs of the patients.
									</p>
								</div> */}
								<a className="navbar-brand" href="/physical/examination">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Physical Examination General
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-flask"></i>
									</div>
									<h3><a href="/physical/examination">Physical Examination</a></h3>
									<p>
										Pathology Laboratory performs tests on a Routine Basis and STAT according to the needs of the patients.
									</p>
								</div> */}
								<a className="navbar-brand" href="/physical/examination/induction">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Physical Examination Induction
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>
							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-flask"></i>
									</div>
									<h3><a href="/physical/examination">Physical Examination</a></h3>
									<p>
										Pathology Laboratory performs tests on a Routine Basis and STAT according to the needs of the patients.
									</p>
								</div> */}
								<a className="navbar-brand" href="/physical/examination/pelvic">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Physical Examination Pelvic
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>
							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-flask"></i>
									</div>
									<h3><a href="/physical/examination">Physical Examination</a></h3>
									<p>
										Pathology Laboratory performs tests on a Routine Basis and STAT according to the needs of the patients.
									</p>
								</div> */}
								<a className="navbar-brand" href="/physical/examination/inspection">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Physical Examination <br></br>Inspection
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>


							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/preplan/analysis">Preplan Analysis Executed</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/preplan/analysis">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Preplan Analysis Executed
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>
							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/previous/obstetrics/history">Previous Obstetrics History</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/previous/obstetrics/history">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Previous Obstetrics History
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/sexual/history">Sexual History</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/sexual/history">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Sexual History
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/previous/pregnancy/complication">Previous Pregnant Complication</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/previous/pregnancy/complication">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Previous Pregnancy <br />Complication
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-4 col-sm-6  mb-4 col-xs-12  center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="">Prior Ob Or Gyn Infections</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/prior/ob/or/gyn/infections">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Prior Ob Or Gyn Infections
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="">Utilization Of Drugs</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/utilization/of/drugs">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Utilization Of Drugs
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  ">
								{/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="">Utilization Of Drugs</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
								<a className="navbar-brand" href="/triage/medical/disorders">
									<Card className="innerdashboardcards center" variant="outlined">
										<CardActionArea>
											<div className='full-width center pt-4'>
												<CardMedia className='fa fa-plus-square icon-medium color-blue'
													component="icon"
													alt="Triage"
												/>

											</div>
											<CardContent>
												<Typography align="center" gutterBottom variant="h6" component="div" className='color-blue'>
													Medical Disorders
												</Typography>
												<Typography gutterBottom component="div" variant="p" align='center' paragraph="true" className='innerdashcardsp'>

												</Typography>
											</CardContent>
										</CardActionArea>
									</Card>
								</a>
							</div>

							<div className="col-md-6 col-lg-4  col-sm-12 mb-4  col-xs-12 center  "></div>

						</div>
						<a className="btn btn-primary sendToModule">Send to Module</a>
					</div>

				</section>

				<div className="modal module_list" tabIndex="-1" role="dialog">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title PatientName"></h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className='full-width'>
									<form onSubmit={this.handleSubmit}>
										<div className="form-row pt-4">

											<div className="col-md-4 p-2">
												<div className="py-1">
													<h6 className="text-capitalize" style={fontFamilyNunito}>Choose Module</h6><select onChange={this.handleChange} value={module} name="module" className="form-control selectModule">
														<optgroup label="Attended Antenatal Care">
															<option selected disabled></option>
															<option value="gynecology" >Gynecology Ward</option>
															<option value="gynecology2" >Gynecology Ward II</option>
															<option value="labour" >Labour Room </option>
															<option value="delivery">Delivery </option>
															<option value="newborn">New Born Unit </option>
															<option value="theatre">Theatre </option>
															<option value="lab">Laboratory</option>


														</optgroup>
													</select>
												</div>


											</div>
										</div>


										<div className="row">
											{/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
											<div className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold" type="submit" style={floatLeft}>Submit</button></div>
										</div>

									</form>
								</div>


							</div>
							<div className="modal-footer">
								<p className="alert alert-success sendModuleSuccess" style={displayHidden}>Patient Sent Successfully</p>
								{/* <button type="button" className="btn btn-primary sendToModule" id="">Send To Module</button> */}
								{/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default TriageDashboard
